module.exports = __webpack_public_path__ + "img/complete.163f7bac.svg";